import lifehack1 from './lifehacks/lifehack-1';
import lifehack2 from './lifehacks/lifehack-2';
import lifehack3 from './lifehacks/lifehack-3';
import lifehack4 from './lifehacks/lifehack-4';
import lifehack5 from './lifehacks/lifehack-5';
import lifehack6 from './lifehacks/lifehack-6';

const initArticleAnimation = () => {
	if ($(window).width() > 1025) {
		lifehack1(
			$('.article__figure-icon--lifehack-1-star'),
			$('.article__figure-icon--lifehack-1-nose')
		);

		lifehack2(
			$('.article__figure-icon--lifehack-2-star'),
			$('.article__figure-icon--lifehack-2-backstar'),
			$('.article__figure-icon--lifehack-2-ball')
		);

		lifehack3(
			$('.article__figure-icon--lifehack-3-star'),
			$('.article__figure-icon--lifehack-3-backstar'),
			$('.article__figure-icon--lifehack-3-dot-1'),
			$('.article__figure-icon--lifehack-3-dot-2'),
			$('.article__figure-icon--lifehack-3-dot-3')
		);

		lifehack4(
			$('.article__figure-icon--lifehack-4-money'),
			$('.article__figure-icon--lifehack-4-nose'),
			$('.article__figure-icon--lifehack-4-eye-open-left')
		);

		lifehack5(
			$('.article__figure-icon--lifehack-5-star'),
			$('.article__figure-icon--lifehack-5-o')
		);

		lifehack6(
			$('.article__figure-icon--lifehack-6-arrow'),
			$('.article__figure-icon--lifehack-6-o')
		);
	}
};

const destroyArticleAnimation = () => {
	TweenMax.killTweensOf([$('.article__figure-icon')]);
	TweenMax.set([$('.article__figure-icon')], {clearProps: 'all'});
};

export {
	initArticleAnimation,
	destroyArticleAnimation,
};
